import * as moment from 'moment';
import { useEffect, useState } from 'react';
import MyDTPicker from './date-time-picker-with-close-button';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    property: string,
    currentValue: string,
    disabled?: boolean,
    includeStyle?: boolean,
    showTime?: boolean,
    borderColor?: string,
    borderWidth?: number,
    setWidth100?: boolean,
    titleText?: string,
    backgroundColor?: string,
    color?: string,
    dateFormat?: string,
    useCloseButton?: boolean,
    onValueChanged: (property: string, moment: moment.Moment) => void
    isValidDate?: (currentDate: moment.Moment, selectedDate: moment.Moment) => boolean;
}

const DateTimePicker = (props: IProps) => {
    const [value, setValue] = useState('');
    const [isValid, setIsValid] = useState(true);

    const previousProperty = usePrevious(props.property);
    const previousValue = usePrevious(props.currentValue);

    useEffect(() => {
        if (previousProperty != props.property || previousValue != props.currentValue) {
            setValue(props.currentValue);
        }
    }, [props.property, props.currentValue]);

    const handleChange = (value: moment.Moment) => {
        let dateFormat = props.dateFormat != undefined ? props.dateFormat : 'MM/DD/YY';
        let format = props.showTime == undefined || props.showTime ? dateFormat + ' HH:mm' : dateFormat;

        setValue(typeof value != 'string' ? value.format(format) : value);
        setIsValid(typeof value != 'string');
    };

    const handleClose = () => {
        let dateFormat = props.dateFormat != undefined ? props.dateFormat : 'MM/DD/YY';
        let format = props.showTime == undefined || props.showTime ? dateFormat + ' HH:mm' : dateFormat;

        let newValue = moment(value, format);
        let isValid = newValue.isValid();

        if (isValid) {
            props.onValueChanged(props.property, newValue);
        }

        setIsValid(true);
    };

    const disabled = props.disabled != undefined ? props.disabled : false;
    const showTime = props.showTime == undefined || props.showTime ? 'HH:mm' : false;
    const title = props.titleText ? props.titleText : null;
    const backgroundColor = props.backgroundColor != undefined && !disabled ? props.backgroundColor : 'white';
    const color = props.color != undefined && !disabled ? props.color : '#555';
    const dateFormat = props.dateFormat != undefined ? props.dateFormat : 'MM/DD/YY';

    let style = props.includeStyle == false ?
        { borderColor: isValid ? '#ccc' : '#a94442', borderWidth: 1 }
        :
        { padding: '3px 6px', height: 26, width: 120, borderColor: isValid ? '#ccc' : '#a94442', borderWidth: 1, backgroundColor, color };

    style.borderColor = props.borderColor ? props.borderColor : style.borderColor;
    style.borderWidth = props.borderWidth ? props.borderWidth : style.borderWidth;

    const useCloseButton = props.useCloseButton != undefined ? props.useCloseButton : false;

    return (
        <MyDTPicker
            value={value}
            input={true}
            useCloseButton={useCloseButton}
            dateFormat={dateFormat}
            timeFormat={showTime}
            closeOnSelect={false}
            closeOnClickOutside={true}
            inputProps={{ style, disabled: disabled, className: 'form-control', title }}
            onChange={handleChange}
            onClose={handleClose}
            isValidDate={props.isValidDate}
        />
    );
}

export default DateTimePicker;